addEventListener('load', function () {
  const productTemplate = document.querySelector('.template-product');
  const indexTemplate = document.querySelector('.template-index');

  /* Sticky header
  ================================*/
  function stickyHeader() {
    const headerWrapper = document.querySelector('#shopify-section-header');
    const logos = document.querySelectorAll('.header-logo-wrapper .site-header__logo');
    const topBar = document.querySelector('.notification__bar');
    const headerObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          headerWrapper.classList.remove('header--sticky');
          for (let logo of logos) {
            logo.classList.remove('site-header__logo--sticky');
          }
        } else {
          headerWrapper.classList.add('header--sticky');
          for (let logo of logos) {
            logo.classList.add('site-header__logo--sticky');
          }
        }
      });
    });

    headerObserver.observe(topBar);
  }
  stickyHeader();

  /* Mobile menu Extras
  ================================*/
  function MenuExtras() {
    const extraLinks = document.querySelectorAll('.notification__bar--valueprop a[data-menu]');
    //append in mobile nav
    if (extraLinks.length) {
      let mobileNav = document.querySelector('.mobile-menu-main');
      let list = document.createElement('ul');
      mobileNav.insertAdjacentHTML(
        'afterend',
        `<div class="mobile-menu-extra mobile-menu-bar"><span>${extraLinks[0].dataset.menu}</span>${menuLinks()}</div>`
      );
      function menuLinks() {
        list.classList.add('mobile-menu', 'mobile-menu-child');
        for (let link of extraLinks) {
          list.insertAdjacentHTML('afterbegin', `<li>${link.outerHTML}</li>`);
        }
        return list.outerHTML;
      }
    }
  }
  MenuExtras();

  /* Indiv product ATC button
  ===================================*/
  (function ajaxATC() {
    document.querySelectorAll('.featured__product--atc').forEach(function (atc) {
      atc.addEventListener('click', function () {
        let value = atc.dataset.variantId;
        let data = { id: value, quantity: 1 };
        let cartCountNodes = document.querySelectorAll('.cart-item-count-header.cart-item-count-header--quantity');
        let productCard = atc.parentElement;
        let cartCount = 0;
        let atcText = atc.querySelector('.btn__add-to-cart-text');
        var addedTextTimeout = null;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        })
          .then(res => res.json())
          .then(res => {
            //update cart count
            cartCount = +cartCountNodes[0].textContent;
            cartCountNodes.forEach(function (node) {
              node.textContent = cartCount + 1;
            });
            //switch btn text
            atcText.textContent = wetheme.translations.added;
            productCard.classList.add('hover');
            if (addedTextTimeout) {
              clearTimeout(addedTextTimeout);
              addedTextTimeout = null;
            }
            addedTextTimeout = setTimeout(function () {
              atcText.textContent = wetheme.translations.add;
              productCard.classList.remove('hover');
            }, 2000);
            if (!window.MaxDesign?.optimize?.cartDrawer.running) window.MaxDesign.cartDrawer.fetchCart();
          })
          .catch(console.error);
      });
    });
  })();

  /* Variant Bundle
  ===================================*/
  function variantBundle() {
    const variantBundle2 = document.querySelector('form [data-bundle-description2]'),
      variantBundle3 = document.querySelector('form [data-bundle-description3]');

    if (variantBundle2 || variantBundle3) {
      let variants = document.querySelectorAll('.swatch .swatch-element, .md-bundle__block');
      let description = document.querySelectorAll('.product-description-wrapper');
      let initialDescription = description[0].innerHTML;
      let initialDescriptionSplit = description[1] ? description[1].innerHTML : '';
      let variantDescription2 = variantBundle2 ? variantBundle2.dataset.bundleDescription2 : null;
      let variantDescription3 = variantBundle3 ? variantBundle3.dataset.bundleDescription3 : null;
      let productThumbnails = document.querySelector('.product-single__thumbnails');
      let productTitle = document.querySelector('.reviews-enabled');
      let initialProductTitle = productTitle.textContent;

      variants.forEach(function (variant) {
        variant.addEventListener('click', function (e) {
          if (
            (variantBundle2 && e.currentTarget.hasAttribute('data-bundle-description2')) ||
            e.currentTarget.dataset.bundleIndex == '1'
          ) {
            description[0].innerHTML =
              variantDescription2 == '' || variantDescription2.includes('<!-- -->')
                ? initialDescription
                : variantDescription2;
            if (description[1]) {
              description[1].innerHTML =
                variantDescription2 == ''
                  ? initialDescriptionSplit
                  : variantDescription2.includes('<!-- -->')
                  ? variantDescription2
                  : '';
            }
            variantDescription2 == ''
              ? productThumbnails.classList.remove('bundle-variant-enabled')
              : productThumbnails.classList.add('bundle-variant-enabled');
            productTitle.textContent = variantDescription2 == '' ? initialProductTitle : variantBundle2.textContent;
          } else if (
            (variantBundle3 && e.currentTarget.hasAttribute('data-bundle-description3')) ||
            e.currentTarget.dataset.bundleIndex == '2'
          ) {
            description[0].innerHTML =
              variantDescription3 == '' || variantDescription3.includes('<!-- -->')
                ? initialDescription
                : variantDescription3;
            if (description[1]) {
              description[1].innerHTML =
                variantDescription3 == ''
                  ? initialDescriptionSplit
                  : variantDescription3.includes('<!-- -->')
                  ? variantDescription3
                  : '';
            }
            variantDescription3 == ''
              ? productThumbnails.classList.remove('bundle-variant-enabled')
              : productThumbnails.classList.add('bundle-variant-enabled');
            productTitle.textContent = variantDescription3 == '' ? initialProductTitle : variantBundle3.textContent;
          } else {
            description[0].innerHTML = initialDescription;
            if (description[1]) {
              description[1].innerHTML = initialDescriptionSplit;
            }
            productThumbnails.classList.remove('bundle-variant-enabled');
            productTitle.textContent = initialProductTitle;
          }
        });
      });
    }
  }
  variantBundle();

  /* Go to reviews
  ===================================*/
  (function goToReviews() {
    if (productTemplate) {
      let tabs = document.querySelector('.tabs__list');
      let reviewTab = document.querySelector('.tabs__list > li[data-reviews] > a');
      let headerOffset = document.querySelector('.header-wrapper').offsetHeight;
      let reviewSection = document.querySelector('#judgeme_product_reviews');

      document
        .querySelectorAll('.reviews__wrapper, .socialproof__bottom--link, .socialproof__bottom--write')
        .forEach(function (el) {
          el.addEventListener('click', function (e) {
            e.preventDefault();
            reviewTab && reviewTab.dispatchEvent(new Event('click'));
            reviewSection.classList.add('judgeme_product_reviews--open');
            let reviewsPosition = tabs ? tabs.getBoundingClientRect().top : reviewSection.getBoundingClientRect().top;
            let offsetPosition = reviewsPosition - headerOffset + window.pageYOffset;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
            if (el.classList.contains('socialproof__bottom--write')) {
              document.querySelector('.jdgm-write-rev-link').dispatchEvent(new Event('click'));
            }
          });
        });

      //when coming from home page. Tiemout to reset main thread execution sequence order
      setTimeout(function () {
        if (window.location.hash == '#show_reviews') {
          document.querySelector('.reviews__wrapper').dispatchEvent(new Event('click'));
        } else if (window.location.hash == '#write_reviews') {
          document.querySelector('.socialproof__bottom--write').dispatchEvent(new Event('click'));
        }
      }, 0);
    }
  })();

  document.addEventListener('shopify:section:select', function (evt) {
    variantBundle();
    stickyHeader();
  });

  //End load
});
